/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function CheckIcon(props: IconProps) {
    return (<IconWrapper {...props}>{<path d="M33.391 10.608c.812.75.812 2.06 0 2.808L17.41 29.393c-.749.81-2.06.81-2.81 0l-7.99-7.988a1.924 1.924 0 0 1 0-2.808 1.926 1.926 0 0 1 2.81 0l6.617 6.552 14.546-14.54a1.926 1.926 0 0 1 2.81 0"/>}</IconWrapper>);
}
